import { BudgetTypeEnum } from '@enums/BudgetType';
import { Estimate } from '@interfaces/Estimate';
import { EstimateBudgetTypesEnum } from './estimate-buget-types.enum';

export class EstimateBudgetTypes {
  public constructor(estimate?: Estimate) {
    if (estimate) {
      this.selectedBudgetType = estimate.budgetType;
      this.selectedBudgetTypeExpense = estimate.budgetTypeExpense;
      this.selectedBudgetTypeInternalFee = estimate.budgetTypeInternalFee;
      this.selectedBudgetTypeTime = estimate.budgetTypeTime;
    }
  }

  public get(type: EstimateBudgetTypesEnum) {
    switch (type) {
      case EstimateBudgetTypesEnum.Global: {
        return this.selectedBudgetType;
      }
      case EstimateBudgetTypesEnum.Expense: {
        return this.selectedBudgetTypeExpense;
      }
      case EstimateBudgetTypesEnum.InternalFee: {
        return this.selectedBudgetTypeInternalFee;
      }
      case EstimateBudgetTypesEnum.Time: {
        return this.selectedBudgetTypeTime;
      }
      default: {
        throw Error('unknown ' + typeof EstimateBudgetTypesEnum);
      }
    }
  }

  public set(type: EstimateBudgetTypesEnum, value: BudgetTypeEnum) {
    switch (type) {
      case EstimateBudgetTypesEnum.Global: {
        this.selectedBudgetType = value;
        this.onSelectedBudgetTypeChange();
        return;
      }
      case EstimateBudgetTypesEnum.Expense: {
        this.selectedBudgetTypeExpense = value;
        return;
      }
      case EstimateBudgetTypesEnum.InternalFee: {
        this.selectedBudgetTypeInternalFee = value;
        return;
      }
      case EstimateBudgetTypesEnum.Time: {
        this.selectedBudgetTypeTime = value;
        return;
      }
      default: {
        throw Error('unknown ' + typeof EstimateBudgetTypesEnum);
      }
    }
  }

  public selectedBudgetType: BudgetTypeEnum = BudgetTypeEnum.Summary;
  public selectedBudgetTypeTime?: BudgetTypeEnum = BudgetTypeEnum.Summary;
  public selectedBudgetTypeExpense?: BudgetTypeEnum = BudgetTypeEnum.Summary;
  public selectedBudgetTypeInternalFee?: BudgetTypeEnum = BudgetTypeEnum.Summary;

  public matchesEstimate(currentEstimate: Estimate) {
    return (
      currentEstimate.budgetType === this.selectedBudgetType &&
      currentEstimate.budgetTypeExpense === this.selectedBudgetTypeExpense &&
      currentEstimate.budgetTypeInternalFee === this.selectedBudgetTypeInternalFee &&
      currentEstimate.budgetTypeTime === this.selectedBudgetTypeTime
    );
  }
  private onSelectedBudgetTypeChange() {
    if (this.selectedBudgetType === BudgetTypeEnum.Summary) {
      this.selectedBudgetTypeExpense = BudgetTypeEnum.Summary;
      this.selectedBudgetTypeInternalFee = BudgetTypeEnum.Summary;
      this.selectedBudgetTypeTime = BudgetTypeEnum.Summary;
    } else if (this.selectedBudgetType === BudgetTypeEnum.Detailed) {
      this.selectedBudgetTypeExpense = BudgetTypeEnum.Detailed;
      this.selectedBudgetTypeInternalFee = BudgetTypeEnum.Detailed;
      this.selectedBudgetTypeTime = BudgetTypeEnum.Detailed;
    }
  }
}
